import { parseEntityId } from "./id-parser";
// 61c378dc-f1d8-5555-bbbb-3bd5ab1ca32b
export const CrmAuthorId = parseEntityId("61c378dcf1d83bd5ab1ca32b");
// 7f3e8b1a-2c4d-4591-9876-1e5f3a7b9c2d
export const HostedFormUploadAuthorId = parseEntityId("7f3e8b1a2c4d45919876e5f3a7b9c2d");
export const rootRegionParentId = parseEntityId("2c57076a-5a1c-4afc-b246-0a0b580e9c68");
export const evergreenContactTenantId = parseEntityId("5f6e2f3f-58b2-4484-9fb0-aecd0e591741");
export const evergreenContactAuthorId = parseEntityId("e6727f2c-18f7-4ba0-b9da-f04b8547a4b0");
export const BAA_SESSION_TIMEOUT_MINUTES = 30;
export const BAA_WARNING_BEFORE_TIMEOUT_MINUTES = 5;
//# sourceMappingURL=constants.js.map